export default [{
  path: 'recoveryArchiveList',
  name: 'recoveryArchiveList',
  component: function component() {
    return import('@/views/recoveryManage/recoveryArchiveManage/redact/index');
  }
}, {
  path: 'recoveryArchiveAdd',
  name: 'recoveryArchiveAdd',
  component: function component() {
    return import('@/views/recoveryManage/recoveryArchiveManage/redact/add');
  }
}, {
  path: 'recoveryArchiveUpdate',
  name: 'recoveryArchiveUpdate',
  component: function component() {
    return import('@/views/recoveryManage/recoveryArchiveManage/redact/update');
  }
}, {
  path: 'recoveryArchiveDetails',
  name: 'recoveryArchiveDetails',
  component: function component() {
    return import('@/views/recoveryManage/recoveryArchiveManage/redact/detail');
  }
}, {
  path: 'recoveryArchiveReviewList',
  name: 'recoveryArchiveReviewList',
  component: function component() {
    return import('@/views/recoveryManage/recoveryArchiveManage/review/index');
  }
}, {
  path: 'recoveryArchiveReviewDetails',
  name: 'recoveryArchiveReviewDetails',
  component: function component() {
    return import('@/views/recoveryManage/recoveryArchiveManage/review/detail');
  }
}, {
  path: 'recoveryArchiveStatisticsList',
  name: 'recoveryArchiveStatisticsList',
  component: function component() {
    return import('@/views/recoveryManage/recoveryArchiveManage/statistics/index');
  }
}];